// extracted by mini-css-extract-plugin
export default {"social_media_box":"MediaSharing_social_media_box__Fi5Kt"};